export type TFeedbackSentiment = "up" | "down";

type TBuildFeedbackMessage = {
  tag?: string;
  sentiment?: TFeedbackSentiment;
  options?: string[];
  context?: string;
  note: string;
};

const SENTIMENT_LABEL: Record<TFeedbackSentiment, string> = {
  up: "👍 Loving it",
  down: "👎 Needs work",
};

// feedbackSubmit only takes free text, so structured picks are flattened into
// one scannable Slack line.
export const buildFeedbackMessage = ({
  tag,
  sentiment,
  options = [],
  context,
  note,
}: TBuildFeedbackMessage) => {
  const trimmed = note.trim();
  const parts = [
    sentiment && SENTIMENT_LABEL[sentiment],
    options.length > 0 && options.join(", "),
    context,
    trimmed && (sentiment ? `"${trimmed}"` : trimmed),
  ].filter(Boolean);

  const body = parts.join(" · ");
  return tag ? `[${tag}] ${body}` : body;
};
